import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { BaseService } from 'src/app/shared/services/base.service';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { DistanceResponse } from '../interfaces/distance';
import { map } from 'rxjs/operators';
import { Polyline } from '../utils/polyline';
import { formatDuration } from '../utils/seconds-to-duration';

@Injectable({
  providedIn: 'root'
})
export class MapService extends BaseService {
  ctrl = 'map';
  constructor(http: HttpClient, webStorageService: WebStorageService) {
    super(http, webStorageService);
  }

  getDistance(origin: string, destination: string, patientTimezone?: string, departureTime?: Date) {
    if (!origin || !destination) {
      throw new Error('Origin and destination are required.');
    }

    const encodedOrigin = encodeURIComponent(origin);
    const encodedDestination = encodeURIComponent(destination);

    let queryParams = `origin=${encodedOrigin}&destination=${encodedDestination}`;

    if (patientTimezone) {
      const encodedTimezone = encodeURIComponent(patientTimezone);
      queryParams += `&patientTimezone=${encodedTimezone}`;
    }

    if (departureTime) {
      const encodedDepartureTime = encodeURIComponent(departureTime.toISOString());
      queryParams += `&departureTime=${encodedDepartureTime}`;
    }

    return this.get<ResultOfT<DistanceResponse>>(`${this.ctrl}/distance?${queryParams}`).pipe(
      map((result) => {
        if (!result || !result.responseModel) {
          return result;
        }

        const model = result.responseModel;

        const distanceMeters = Number(model.distanceMeters) || 0;
        const durationSeconds = Number(model.durationSeconds) || 0;

        model.durationText = formatDuration(durationSeconds);
        model.distanceMiles = Number((distanceMeters / 1609.34).toFixed(2));
        model.durationMinutes = Number((durationSeconds / 60).toFixed(2));

        if (model.geometry) {
          try {
            model.coordinates = Polyline.decode(model.geometry);
          } catch (error) { }
        }

        return result;
      })
    );
  }
}
